import { put } from "redux-saga/effects";

import { IDeleteCollaboratorAction } from "../types";
import { deleteCollaborator } from "./../actionCreators";

export function* deleteCollaboratorSaga({ payload: { id } }: IDeleteCollaboratorAction) {
    try {
        yield put(deleteCollaborator({ id }));
    } catch (error) {
        // yield put(Handle Error);
    }
}
